<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? 'Update Gudang' : 'Buat Gudang' }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body p-3">
            <div class="form-group">
                <label>Kode</label>
                <input v-model="form.code" type="text" name="code" class="form-control">
                <span class="text-danger">{{ errors.first('code') }}</span>
            </div>
            <div class="form-group">
                <label>Nama</label>
                <input v-validate="'required'" v-model="form.name" type="text" name="name" class="form-control">
                <span class="text-danger">{{ errors.first('name') }}</span>
            </div>
        </div>
        <div class="modal-footer">
            <button @click="save" type="button" class="btn btn-primary">Simpan</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "gudangs-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            form: null,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.isEdit) {
            this.form = Object.assign({}, this.value);
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.form = Object.assign({}, this.value);
        }
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                form: {
                    id: '',
                    code: '',
                    name: '',
                }
            });
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self._save();
                }
            });
        },

        _save() {
            let self = this;

            let data = {
                code: self.form.code,
                name: self.form.name,
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/gudangs/'+self.form.id : '/api/gudangs',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.resetForm();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
